<h2 mat-dialog-title class="dialog-title">
  {{ showEmergencyConfirmation ? 'Emergency Attention Required' : 'Assign Triage Risk Level' }}
</h2>

<mat-dialog-content class="dialog-content">
  <!-- PHASE 1: Normal Level Selection -->
  <ng-container *ngIf="!showEmergencyConfirmation">
    <p class="subtitle">Please assign a final risk level based on the patient's vitals and symptoms.</p>
    
    <mat-radio-group [(ngModel)]="selectedLevel" class="triage-options">
      <mat-radio-button *ngFor="let option of triageLevels" [value]="option.level" class="triage-radio-btn" [ngStyle]="{'--accent-color': option.color}">
        <div class="option-content">
          <div class="color-indicator" [style.backgroundColor]="option.color"></div>
          <span class="option-name">{{ option.name }}</span>
        </div>
      </mat-radio-button>
    </mat-radio-group>
  </ng-container>

  <!-- PHASE 2: Emergency Confirmation -->
  <ng-container *ngIf="showEmergencyConfirmation">
    <div class="emergency-alert">
      <mat-icon color="warn" class="alert-icon">warning</mat-icon>
      <p>This patient requires immediate attention.</p>
    </div>
    <p class="subtitle">Would you like to schedule an emergency appointment right now and delay the doctor's subsequent appointments today by 30 minutes?</p>
    
    <div class="practitioner-select-container">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Assign to Practitioner</mat-label>
        <mat-select [(ngModel)]="selectedPractitionerId" [disabled]="loadingPractitioners">
          <mat-option *ngIf="loadingPractitioners">
            <mat-spinner diameter="20"></mat-spinner> Loading...
          </mat-option>
          <mat-option *ngFor="let p of practitioners" [value]="p.id">
            {{ p.name }} ({{ p.roleDisplay }})
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <!-- PHASE 1 Actions -->
  <ng-container *ngIf="!showEmergencyConfirmation">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!selectedLevel" (click)="submitPhase1()">Submit & Complete</button>
  </ng-container>

  <!-- PHASE 2 Actions -->
  <ng-container *ngIf="showEmergencyConfirmation">
    <button mat-button (click)="cancelEmergency()">No, just complete triage</button>
    <button mat-flat-button color="warn" [disabled]="!selectedPractitionerId" (click)="confirmEmergency()">Yes, Create & Delay</button>
  </ng-container>
</mat-dialog-actions>
